import { Toaster as Sonner } from 'sonner';

export const Toaster = ({ ...props }) => {
  return (
    <Sonner
      className="toaster group"
      position="top-center"
      expand={false}
      richColors={false}
      closeButton={false}
      duration={3500}
      gap={12}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-white/95 group-[.toaster]:backdrop-blur-xl group-[.toaster]:text-slate-800 group-[.toaster]:border group-[.toaster]:border-slate-200/60 group-[.toaster]:shadow-[0_8px_30px_rgb(0,0,0,0.06)] group-[.toaster]:rounded-2xl group-[.toaster]:px-5 group-[.toaster]:py-4 group-[.toaster]:font-medium group-[.toaster]:tracking-tight',
          title: 'group-[.toast]:text-[15px] group-[.toast]:font-semibold group-[.toast]:text-slate-900 group-[.toast]:leading-snug',
          description: 'group-[.toast]:text-[13px] group-[.toast]:text-slate-500 group-[.toast]:font-normal group-[.toast]:leading-relaxed group-[.toast]:mt-1',
          actionButton:
            'group-[.toast]:bg-slate-900 group-[.toast]:text-white group-[.toast]:text-[13px] group-[.toast]:font-medium group-[.toast]:rounded-lg group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:shadow-sm group-[.toast]:hover:bg-slate-800 group-[.toast]:transition-colors',
          cancelButton:
            'group-[.toast]:bg-slate-100 group-[.toast]:text-slate-600 group-[.toast]:text-[13px] group-[.toast]:font-medium group-[.toast]:rounded-lg group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:hover:bg-slate-200 group-[.toast]:transition-colors',
          success:
            'group-[.toaster]:bg-emerald-50/95 group-[.toaster]:border-emerald-200/60 group-[.toaster]:text-emerald-900',
          error:
            'group-[.toaster]:bg-rose-50/95 group-[.toaster]:border-rose-200/60 group-[.toaster]:text-rose-900',
          warning:
            'group-[.toaster]:bg-amber-50/95 group-[.toaster]:border-amber-200/60 group-[.toaster]:text-amber-900',
          info:
            'group-[.toaster]:bg-sky-50/95 group-[.toaster]:border-sky-200/60 group-[.toaster]:text-sky-900',
          icon: 'group-[.toast]:w-5 group-[.toast]:h-5',
        },
      }}
      style={{
        '--width': '380px',
      }}
      {...props}
    />
  )
}
